import apiClient from '../../utils/apiClient';

const API_URL = '/admin/service-state-access';

export async function getAllServiceStateAccess() {
  const response = await apiClient.get(API_URL);
  return response.data;
}

export async function createServiceStateAccess(payload) {
  const response = await apiClient.post(API_URL, payload);
  return response.data;
}

export async function updateServiceStateAccess(id, payload) {
  try {
    const response = await apiClient.put(`${API_URL}/${id}`, payload);
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      const response = await apiClient.patch(`${API_URL}/${id}`, payload);
      return response.data;
    }
    throw err;
  }
}

export async function toggleServiceStateAccessStatus(id) {
  const response = await apiClient.patch(`${API_URL}/${id}/status`);
  return response.data;
}

export async function deleteServiceStateAccess(id) {
  const response = await apiClient.delete(`${API_URL}/${id}`);
  return response.data;
}
